import Schedule from '../../containers/schedule/index'
import AppShell from '../../components/layout/AppShell'

export default function SchedulePage() {
    return (
        <AppShell title="Расписание">
            <Schedule />
        </AppShell>
    )
}
